import { setSelected } from '../../utils/filter/selection';

const regionsOptions = [
    {
        label: 'GB',
        value: 'GB',
    },
    {
        label: 'Ireland',
        value: 'IRE',
    },
    {
        label: 'GB and Ireland',
        value: 'GB-IRE',
    },
    {
        label: 'Europe',
        value: 'Europe',
    },
    {
        label: 'USA',
        value: 'USA',
    },
    {
        label: 'All',
        value: 'All',
    },
];

const displayByOptions = [
    {
        label: 'Foals',
        value: 'foals',
    },
    {
        label: 'Yearlings',
        value: 'yearlings',
    },
    {
        label: '2yo',
        value: '2yo',
    },
    {
        label: '3yo',
        value: '3yo',
    },
    {
        label: '4yo',
        value: '4yo',
    },
    {
        label: 'Older horses',
        value: 'older',
    },
    {
        label: 'Mares',
        value: 'mares',
    },
];

const regionsFactory = region => ({
    title: 'regions',
    options: setSelected(regionsOptions, region),
});

const displayByFactory = displayBy => ({
    title: 'display by',
    options: setSelected(displayByOptions, displayBy),
});

const categoriesFactory = (region, displayBy) => ({
    regions: regionsFactory(region),
    displayBy: displayByFactory(displayBy),
});

export default categoriesFactory;



// WEBPACK FOOTER //
// ./src/js/horse/salesStatistics/categories.js